import React from "react"

import {AppProvidersAutocomplete} from "@components"
import {useUserSettingsTier, useUserSettingsTierValidator} from "../../@hooks"
import {userSettingsTierFormData} from "../../@signals"


export default function UserSettingTierDrawerProviders() {
	const {handleChangeTierFormData} = useUserSettingsTier()
	const {providersError} = useUserSettingsTierValidator()

    return <AppProvidersAutocomplete
		multiple
		placeholder="Select a providers"
		error={providersError}
		value={userSettingsTierFormData.value?.providers || []}
		onChange={e => handleChangeTierFormData(e.target.value, 'providers')}
	/>
}